import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  roles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, roles }) => {
  const { user, loading } = useAuth();
  console.log('🔒 ProtectedRoute - user:', user, 'loading:', loading, 'roles:', roles);

  // v1.5.2: role → home route mapping (prevents infinite redirect loops)
  const ROLE_HOME: Record<string, string> = {
    farmer: '/farmer-dashboard',
    driver: '/truck-portal',
    field_agent: '/field-agent',
    admin: '/admin',
    finance: '/finance',
    factory_clerk: '/factory-clerk',
    // v1.6.3: warehouse portal accessible to factory_clerk + admin
    // (no separate 'warehouse' role — the factory clerk IS the warehouse person)
    dpo: '/admin',
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-ink-50 dark:bg-ink-950 flex items-center justify-center">
        <div className="text-ink-500 text-xl">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If role is allowed for this route, render the children
  if (!roles || roles.includes(user.role)) {
    return <>{children}</>;
  }

  // Otherwise redirect to the user's home route
  const homeRoute = ROLE_HOME[user.role] || '/dashboard';
  return <Navigate to={homeRoute} replace />;
};

export default ProtectedRoute;
